import { ICreatePermissaoGrupoAcessoUseCase } from "../../../presentation/useCases/create/create_permissao_grupo_acesso_use_case";
import { PermissaoCadastro } from "../../models/permissao_cadastro";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * CreatePermissaoGrupoAcessoUseCase
 */

export class CreatePermissaoGrupoAcessoUseCase implements ICreatePermissaoGrupoAcessoUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(permissaoCadastroLista: PermissaoCadastro[], idGrupoAcesso: number): Promise<void> {
    await this.repository.createPermissaoGrupoAcesso(permissaoCadastroLista, idGrupoAcesso);

  }
}
